/* eslint-disable no-throw-literal */
/* eslint-disable import/prefer-default-export */
import qs from 'qs';


/**
 * Fetch with timeout handling.
 */
export async function fetchWithTimeout(url, options, timeout, onTimeout) {
  const timer = new Promise((resolve) =>
    setTimeout(() => resolve({ timeout: true }), timeout)
  );

  const response = await Promise.race([fetch(url, options), timer]);

  if (response.timeout) {
    onTimeout();
    throw new Error('Request timed out');
  }

  return response;
}


/**
 * Helper function to make API requests with error handling.
 */
async function apiRequest(endpoint, body = {}, method = 'POST', timeout = 10000) {
  try {
    const response = await fetchWithTimeout(
      `${process.env.REACT_APP_API_ENDPOINT}/${endpoint}`,
      {
        body: JSON.stringify(body),
        method,
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      },
      timeout,
      () => {
        throw new Error(`The request timed out`);
      }
    );
    console.log("body", body, "reponse:", response)
    if (!response.ok) {

      throw new Error(`Error in ${endpoint}: ${response.statusText}`);
    }
    const data = await response.json();
    console.log("data", data, "reponse:", response)
    
    return data.d || { Success: false };
  } catch (error) {
    console.error(`API Error in ${endpoint}:`, error);
    return { Success: false, Message: error.message || 'An error occurred' };
  }
}


// AUTHENTICATION & USER MANAGEMENT FUNCTIONS

export async function attemptForgotPassword(email, origin = navigator.userAgent, identityProvider = 'user-password') {
  return apiRequest('HHSForgotPassword', { Email: email, Origin: origin, IdentityProvider: identityProvider});
}


export async function attemptResetPassword(resetUuid, password, origin = navigator.userAgent, identityProvider = 'user-password') {
  return apiRequest('HHSResetPassword', { UserUUID: resetUuid, NewPassword: password, Origin: origin, IdentityProvider: identityProvider });
}



export async function attemptSignup(email, password, name, zip, origin = navigator.userAgent, identityProvider = 'user-password') {
  return apiRequest('HHSSignup', { FirstName: name, Email: email, Password: password, Zipcode: zip, Origin: origin, IdentityProvider: identityProvider });
}


export async function attemptLogin(email, password, origin = navigator.userAgent, identityProvider = 'user-password') {
  const response = await apiRequest('Login', { Email: email, Password: password, Origin: origin, IdentityProvider: identityProvider });

  if (response.Success) return response;
  return { Success: false, Message: response.Message || 'Login failed' };
}

export async function getHHSUserFromAuthID({ AuthID, TimezoneOffset = 0, Origin = navigator.userAgent, IdentityProvider = 'user-password' }) {
  return apiRequest('GetHHSUserFromAuthID', { AuthID, Origin, IdentityProvider, TimezoneOffset });
}

export async function getHHSUserFromGoogleID({ Email, AuthID, TimezoneOffset = 0, Origin = navigator.userAgent, IdentityProvider = 'user-password' }) {
  return apiRequest('GetHHSUserFromGoogleID', { Email, AuthID, Origin, IdentityProvider, TimezoneOffset });
}

export async function updateHHSUser({ user, Origin = navigator.userAgent, IdentityProvider = 'user-password' }) {
  return apiRequest('UpdateHHSUser', { user, Origin, IdentityProvider });
}

export async function getHHSStats({ UserID, TimezoneOffset = 0 }) {
  return apiRequest('GetHHSStats', { UserID, TimezoneOffset });
}

export async function getHHSUserFromUUID(UUID) {
  return apiRequest('GetHHSUserFromUUID', { UUID });
}

export async function getR2gDonationHistory({ UserUUID }) {
  return apiRequest('GetUserCouponHistory', { UserUUID });
}


// DATA RETRIEVAL FUNCTIONS

export async function getCauseList(params) {
  const url = `${process.env.REACT_APP_CDDS_API_ENDPOINT}/api/Cause/CDDSCauses?${qs.stringify(params)}`;
  
  try {
    const response = await fetchWithTimeout(url, { method: 'GET', headers: { 'Content-Type': 'application/json', Accept: 'application/json' } }, 10000, () => {
      throw new Error('Session Timed out');
    });

    if (!response.ok) {
      throw new Error('Error fetching cause list');
    }

    return await response.json();
  } catch (error) {
    console.error('Error in getCauseList:', error);
    return { Success: false, Message: error.message };
  }
}

export async function getSchoolsByZipCode({ Serial, SessionUUID, DateSubmitted, UserID, AccountID, ProgramID, DefaultSchool, ProductID, ProductName, ScanValue }) {
  return apiRequest('GetHHSSchools', { Serial, SessionUUID, DateSubmitted, UserID, AccountID, ProgramID, DefaultSchool, ProductID, ProductName, ScanValue }, 'POST', 5000);
}

// PAGE VIEW TRACKING

export async function submitHHSPageView({ UserID, AccountID, SponsorID, Pathname, Ref }) {
  return apiRequest('SubmitHHSPageView', {
    PageView: { UserID, AccountID, SponsorID, Pathname, Ref, TimezoneOffset: new Date().getTimezoneOffset() },
  });
}